import React, { Component } from 'react'
import { buildPath } from '../utils/route_utils.js'
import { trackEvent } from '../utils/analytics.js'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

import '../css/Footer.css';

class Footer extends Component {
    constructor(props) {
        super(props)

        this.navigate = this.navigate.bind(this)
        this.openInNewTab = this.openInNewTab.bind(this)
    }

    navigate(route) {
        if (this.props.navigate) {
            this.props.navigate(route);
        } else {
            window.location.href = buildPath(this.props.lang, route);
        }
    }

    openInNewTab(url) {
        var win = window.open(url, '_blank');
        if (win != null) {
            win.focus();
        }
    }

    render() {
        const lang = this.props.lang;
        const content = [
            {
                "title": { "en": "About Us", "zh": "關於我們", "ja": "会社情報" },
                "content": {
                    "en": ["Home", "About Nexuni", "Technology", "How to Collaborate?", "Careers"],
                    "zh": ["首頁", "公司理念", "核心技術", "合作流程", "人才招募"],
                    "ja": ["ホーム", "Nexuni について", "技術", "協力方法", "採用情報"]
                },
                "targets": [
                    { route: '/' },
                    { route: '/about/about_us' },
                    { route: '/core-technology' },
                    { route: '/about/colab_flow' },
                    { route: '/about/career' }
                ]
            },
            {
                "title": { "en": "Media", "zh": "媒體影音", "ja": "メディア" },
                "content": {
                    "en": ["Media", "Youtube", "Blog"],
                    "zh": ["媒體", "Youtube", "部落格"],
                    "ja": ["メディア", "Youtube", "ブログ"]
                },
                "targets": [
                    { route: '/about/news' },
                    { url: 'https://www.youtube.com/@nexuni' },
                    { route: '/blog' }
                ]
            },
            {
                "title": { "en": "Contact Us", "zh": "聯繫我們", "ja": "お問い合わせ" },
                "content": {
                    "en": ["Instagram", "Linkedin", "Facebook", "Contact us"],
                    "zh": ["Instagram", "Linkedin", "Facebook", "聯絡我們"],
                    "ja": ["Instagram", "Linkedin", "Facebook", "お問い合わせ"]
                },
                "targets": [
                    { url: 'https://www.instagram.com/nexuni.co/' },
                    { url: 'https://www.linkedin.com/company/nexuni' },
                    { url: 'https://www.facebook.com/profile.php?id=100070603490643' },
                    { route: '/contact' }
                ]
            }
        ];

        const socialLinks = [
            { icon: <LinkedInIcon />, url: "https://www.linkedin.com/company/nexuni" },
            { icon: <YouTubeIcon />, url: "https://www.youtube.com/@nexuni" },
            { icon: <FacebookIcon />, url: "https://www.facebook.com/profile.php?id=100070603490643" },
            { icon: <InstagramIcon />, url: "https://www.instagram.com/nexuni.co/" }
        ];

        const demoText = { en: "Book a Demo", zh: "預約展示", ja: "デモを予約" };
        const currentYear = new Date().getFullYear();

        return (
            <footer className="v2_footer_section" role="contentinfo">
                <div className="v2_footer_top">
                    <div className="v2_footer_logo_area">
                        <a href={buildPath(lang, '/')} className="v2_footer_logo_link" onClick={(e) => { e.preventDefault(); this.navigate('/'); }}>
                            <img src="/assets/mainpage_nexuni_black.png" alt="Nexuni" className="v2_footer_logo" />
                        </a>
                        <div className="v2_footer_social_icons">
                            {socialLinks.map((link, idx) => (
                                <button key={idx} className="v2_footer_social_btn" onClick={() => { trackEvent('footer_social', { url: link.url }); this.openInNewTab(link.url); }} aria-label={link.url}>
                                    {link.icon}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="v2_footer_btn_section">
                    {content.map((item, index) => (
                        <div key={index} className="v2_footer_btn_list">
                            <h4>{item["title"][lang]}</h4>
                            {item["targets"].map((t, i) => {
                                const label = item["content"][lang][i];
                                const isExternal = !!t.url;
                                const href = isExternal ? t.url : buildPath(lang, t.route);
                                return (
                                    <a key={i} href={href}
                                       {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                       onClick={(e) => {
                                           e.preventDefault();
                                           trackEvent('footer_link', { link_text: label, location: 'footer' });
                                           if (isExternal) this.openInNewTab(t.url);
                                           else this.navigate(t.route);
                                       }}>
                                        <span>{label}</span>
                                    </a>
                                );
                            })}
                        </div>
                    ))}
                </div>
                <div className="v2_copyright_section">
                    <div className="v2_copyright">&copy;{currentYear} - <strong>Nexuni Co Ltd. All rights reserved.</strong></div>
                    <div className="v2_footer_legal_links">
                        <a className="v2_security_policy_btn" href={buildPath(lang, '/about/security_policy')} onClick={(e) => { e.preventDefault(); this.navigate('/about/security_policy'); }}>
                            <span>{lang === 'en' && "Information Security Policy"}
                            {lang === 'zh' && "資訊安全政策"}
                            {lang === 'ja' && "情報セキュリティ方針"}</span>
                        </a>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;
